import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  setPersistence,
  browserLocalPersistence
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD1OZEixPC8eeLHBsyoK3BEq23vi7cwJNc",
  authDomain: "androidbridgesoftware.firebaseapp.com",
  databaseURL: "https://androidbridgesoftware.firebaseio.com",
  projectId: "androidbridgesoftware",
  storageBucket: "androidbridgesoftware.firebasestorage.app",
  messagingSenderId: "1016528818171",
  appId: "1:1016528818171:web:001b6d54812e107fac055e",
  measurementId: "G-V3KCT0CM1M"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
// const db = app.firestore();

// Set persistence globally on app initialization
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error("Failed to set Firebase persistence:", error);
});

// export { auth, googleProvider };

// export default db;


